export const validateEmail = (email: string) =>
    Object.assign(document.createElement('input'), {
        type: 'email',
        required: true,
        value: email,
    }).validity.valid
